import axios from 'axios';

/**************************
 * Axios - App Base API URL
 **************************/
const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});

export default API;
